import React, { useState } from 'react';
import redirectGPTIcon from '../images/svgLatest/redirectGPTIcon.svg';
import downloadGPTIcon from '../images/svgLatest/downloadGPTIcon.svg';
import parse from 'html-react-parser';
import Markdown from "markdown-to-jsx";
import DOMPurify from "dompurify";
const TechGPT =({content}) => {
    const [isExpanded, setIsExpanded] = useState(false);
    let summaryText = DOMPurify.sanitize(content.summary);
    const formattedHTML = DOMPurify.sanitize(content.summary);
    
    const summaryReferences = content.summaryReferences;
    const referenceTitle = content.relevantReferenceTitle;
    const references = content.relevantReferences;
    const summaryTitle = content.summaryTitle;
const truncateHTML = (htmlString, maxLength) => {
  const wrapper = document.createElement('div');
  wrapper.innerHTML = htmlString;

  let charactersCounted = 0;
  let htmlAccumulator = '';

  const traverse = (node) => {
    if (charactersCounted >= maxLength) return;

    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.textContent.slice(0, maxLength - charactersCounted);
      charactersCounted += text.length;
      htmlAccumulator += text;
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      const startTag = `<${node.tagName.toLowerCase()}`;
      const attributes = Array.from(node.attributes).map(attr => ` ${attr.name}="${attr.value}"`).join('');
      htmlAccumulator += startTag + attributes + '>';

      node.childNodes.forEach(childNode => traverse(childNode));

      htmlAccumulator += `</${node.tagName.toLowerCase()}>`;
    }
  };

  Array.from(wrapper.childNodes).forEach(node => traverse(node));

  return htmlAccumulator;
};

 const shorthtml = truncateHTML(formattedHTML, 100);
// Output the result
    return (
        <div className="botActivityClass activityClass">
            <div className="botTextBox conversationTextBox">
                <div className="summary-container">
                    <div className="summary-header">
                        <h2>{content.summaryTitle}</h2>
                    </div>
                    <div className="conv-text" style={{ whiteSpace:"pre-line"}}>
                        <Markdown options={{
                            overrides: {
                                a: ({ node, ...props }) => (
                                    <a
                                        {...props}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {props.children}
                                    </a>
                                ),
                                //Paragraph with margin and line height of 2em
                                p: ({ node, ...props }) => (
                                    <p
                                        {...props}
                                    >
                                        {props.children}
                                    </p>
                                ),
                                ul: ({ node, ...props }) => (
                                    <ul
                                        {...props}
                                    >
                                        {props.children}
                                    </ul>
                                ),
                                li: ({ node, ...props }) => (
                                    <li
                                        {...props}>
                                        {props.children}
                                    </li>
                                ),
                                h1: ({ node, ...props }) => (
                                    <h1
                                        {...props}
                                    >
                                        {props.children}
                                    </h1>
                                ),
                                h2: ({ node, ...props }) => (
                                    <h2
                                        {...props}
                                    >
                                        {props.children}
                                    </h2>
                                ),
                                h3: ({ node, ...props }) => (
                                    <h3
                                        {...props}
                                    >
                                        {props.children}
                                    </h3>
                                ),
                                h4: ({ node, ...props }) => (
                                    <h4
                                        {...props}
                                    >
                                        {props.children}
                                    </h4>
                                ),
                                h5: ({ node, ...props }) => (
                                    <h5
                                        {...props}
                                    >
                                        {props.children}
                                    </h5>
                                ),
                                h6: ({ node, ...props }) => (
                                    <h6
                                        {...props}
                                    >
                                        {props.children}
                                    </h6>
                                ),
                                table: ({ node, ...props }) => (
                                    <table
                                        {...props}
                                    >
                                        <tbody>
                                            <tr>
                                                <td
                                                    colSpan={
                                                        Array.isArray(props.children) ? props.children.length : 1
                                                    }
                                                >
                                                    {props.children}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                ),
                            }
                        }}>{isExpanded?summaryText:`${shorthtml}...`}</Markdown>
                    </div>
                    <button onClick={() => setIsExpanded(!isExpanded)} className="read-more-btn">
                        {isExpanded ? "Read Less" : "Read More"}
                    </button>
                    <div className="references">
                        <h3>{referenceTitle}</h3>
                        <ul>
                            {references.map((ref, index) => (
                                <li key={index} className='summaryLi'>
                                    <a href={ref.citationLink} target="_blank" rel="noopener noreferrer">
                                        <span>{index + 1}. {ref.citationTitle}</span>
                                        {ref?.citationLink?.includes("edam")?<img alt="open" src={downloadGPTIcon} />:<img alt="open" src={redirectGPTIcon} />
                                        }
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TechGPT;